// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import PortfolioPage from '@/features/energyxplorer/components/PortfolioPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/dashboard',
)({
  component: PortfolioPage,
  staticData: { crumb: 'glossary:dashboard', hideEnergyAnalysisAppBar: true },
});
